import { useState } from 'react';

import type { Proposal } from '../../api/agentSchemas';
import { personalize, whatsappLink } from './conversation';

/**
 * After approval: one WhatsApp link per person, text already written. The
 * owner sends each from their own phone; a tapped row is marked on this
 * screen only, since nothing tells Dale whether the message actually went.
 */
export function SendList({ proposal }: { proposal: Proposal }) {
  const [opened, setOpened] = useState<readonly string[]>([]);
  if (proposal.draft.kind !== 'message') return null;
  const skip = proposal.draft.skip;
  const recipients = (proposal.recipients ?? []).filter(
    (recipient) => recipient.phone && !skip.includes(recipient.bookingId ?? recipient.customerId),
  );

  return (
    <div className="agents-send-list">
      <p className="section-label">Envíalo desde tu WhatsApp</p>
      <ul className="group rows">
        {recipients.map((recipient) => {
          const key = recipient.bookingId ?? recipient.customerId;
          const link = whatsappLink(recipient.phone, personalize(proposal, recipient));
          const done = opened.includes(key);
          return (
            <li key={key} className="row">
              <div className="grow">
                <p className="row-title">{recipient.name}</p>
                <p className="row-sub">{done ? 'Abriste el chat' : recipient.detail}</p>
              </div>
              {link ? (
                <a
                  className={done ? 'btn small secondary' : 'btn small'}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setOpened((current) => (current.includes(key) ? current : [...current, key]))}
                >
                  {done ? 'Abrir otra vez' : 'Enviar por WhatsApp'}
                </a>
              ) : (
                <span className="row-sub">Sin número de WhatsApp</span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
